/* Custom js here */
if(document.documentElement.lang == 'fr') {
    if($(".header__flag.flag_fr").hasClass("hidden")) {
        $(".header__flag.flag_fr").removeClass("hidden")
    }
    if(!$(".header__flag.flag_de").hasClass("hidden")) {
        $(".header__flag.flag_de").addClass("hidden")
    }
} else {
    if($(".header__flag.flag_de").hasClass("hidden")) {
        $(".header__flag.flag_de").removeClass("hidden")
    }
    if(!$(".header__flag.flag_fr").hasClass("hidden")) {
        $(".header__flag.flag_fr").addClass("hidden")
    }    
}
$(document).ready(function() {
    $(document).on("click", ".header__flag", function() {
        $(".footer__localization .localization-opener__button").trigger("click");
    });
    
    $(document).on("click",".accordion__title", function() {
        $(this).closest(".page-generic__body").find(".accordion_block").slideToggle({
            duration: 300,
            start: function(){
                console.log('start anim')
                if($(this).closest(".page-generic__body").find(".accordion__title svg").hasClass("direction")) {
                    $(this).closest(".page-generic__body").find(".accordion__title svg").removeClass("direction");
                } else {
                    $(this).closest(".page-generic__body").find(".accordion__title svg").addClass("direction");
                }
             },
             done: function() {
                console.log('end anim');
             }
        });
    })
});